<template>
  <div class="c-app">
    <TheSidebar v-if="forcerefresh" />
    <div class="c-wrapper">
      <TheHeader v-if="$store.state.profile.seller.id !== 0" />
      <div class="c-body">
        <b-overlay :show="!$isLoading" rounded="sm" spinner-type="grow">
          <main class="c-main" :aria-hidden="$isLoading ? 'true' : null">
            <CContainer fluid class="px-0">
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </CContainer>
          </main>
        </b-overlay>

        <!-- <div class="chatbox-container">
          <div class="chatbox-header"></div>
          <div
            id="talkjs-container"
            style="width: 90%; margin: 30px; height: 500px"
          >
            <i>Loading chat...</i>
          </div>
        </div> -->
      </div>
      <TheFooter />
    </div>

    <ModalComingSoon ref="modalComingSoon" />
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import Talk from "talkjs";
import ModalComingSoon from "@/components/modal/alert/ModalComingSoon";
import { mapGetters } from "vuex";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    ModalComingSoon,
  },
  data() {
    return {
      forcerefresh: true,
    };
  },
  created() {
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     this.$refs.modalComingSoon.show();
    //   });
    // }, 500);
  },
  watch: {
    refreshFlag: function (value) {
      if (value == true) {
        this.forcerefresh = false;
        this.$nextTick(() => {
          this.forcerefresh = true;
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      refreshFlag: "getRefreshMenu",
    }),
  },
  mounted: function () {
    this.$nextTick(() => {
      this.$store.dispatch("getActiveData");
    });
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
